import { alpha, Box, Divider, Typography } from '@mui/material'
import { useMemo } from 'react'
import { TreeUtils } from '../../../utils/TreeUtils';

/**
 * FDN-569 (Filter Summary)
 */
export const FilterSummary = ({ activeDims, dimFilters, showFilterSummary }) => {

  const { dimCodeToIdToNode, dimCodeToLeafIds } = useMemo(() => {
    const dimCodeToIdToNode = {};
    const dimCodeToLeafIds = {};
    activeDims.forEach(dim => {
      const { leafIds, idToNode } = TreeUtils.parseTree(dim.tree);
      dimCodeToIdToNode[dim.code] = idToNode;
      dimCodeToLeafIds[dim.code] = leafIds;
    })

    return { dimCodeToIdToNode, dimCodeToLeafIds };
  }, [activeDims])

  return (
    <Box
      data-test-id={'filter-summary'}
      sx={(theme) => ({
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
        bgcolor: theme.palette.mode === 'dark' ? alpha(theme.palette.primary.main, 0.1) : theme.palette.primary.light,
        height: '100%',
        padding: theme.spacing(2),
        overflow: 'auto'
      })}
    >
      <Typography variant="h6">Filter Summary</Typography>
      {activeDims.map((dim, index) => {
        const selectedIds = dimFilters[dim.code];
        const allLeafIds = dimCodeToLeafIds[dim.code];

        let displayText;
        if (selectedIds.length === allLeafIds.length) {
          displayText = 'All';
        } else if (selectedIds.length === 0) {
          displayText = 'None';
        } else {
          const idToNode = dimCodeToIdToNode[dim.code];
          displayText = selectedIds.map(id => idToNode[id].name).join(', ');
        }

        return (
          <Box key={dim.code}>
            <Typography variant="subtitle1">{dim.displayName}</Typography>
            <Typography variant="body1">{displayText}</Typography>
            {(index + 1) !== activeDims.length && <Divider />}
          </Box>
        )
      })}
    </Box>
  )
}